import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsBannerImpression,
    getGoogleAnalyticsBannerImpression
} from "./GoogleAnalyticsBannerImpression";

export interface GoogleAnalyticsBannerSlideClick
    extends GoogleAnalyticsBannerImpression {}

const getGoogleAnalyticsBannerSlideClick = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsBannerSlideClick => {
    return getGoogleAnalyticsBannerImpression(
        data,
        GoogleAnalyticsEvents.BannerSlideClick
    );
};

export { getGoogleAnalyticsBannerSlideClick };
